<script lang="ts">
  import Text from "./Text.svelte";

  export let value: string = "";
  export let placeholder: string = "";
  export let label: string = "";
  export let rows: number = 5;
  export let required: boolean = false;
  export let disabled: boolean = false;
  export let errorMessage: string = "";

  let error: string = "";
  let textareaElement: HTMLTextAreaElement;

  $: getErrorMessage = () => errorMessage || "invalid input";
</script>

<label>
  <Text ocd color="transparency-dark">{label}</Text>
  <textarea
    bind:this={textareaElement}
    {required}
    {placeholder}
    bind:value
    {rows}
    on:blur={(_) => {
      error = textareaElement.checkValidity() ? "" : getErrorMessage();
    }}
    {disabled}
  />
</label>
{#if error}
  <div class="error">
    <div class="icon-container">
      <img src="static/assets/icons/icon-info.svg" alt="info" width={11} height={11} />
    </div>
    <div class="error-text">
      <Text ocd>{error}</Text>
    </div>
  </div>
{/if}

<style>
  textarea {
    width: 100%;
    border: 0px;
    background-color: var(--rekki-neutral-01);
    outline-width: 0;
  }

  textarea::placeholder {
    color: var(--rekki-transparency-dark);
  }

  label {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 9px 14px;
    /*margin-left: 10px;*/
    background-color: var(--rekki-neutral-01);
    z-index: 99;
    border-radius: 8px;
  }

  .error {
    background-color: var(--rekki-warning);
    margin-top: 8px;
    border-radius: 8px;
    padding: 9px 10px;
    display: flex;
    flex-direction: row;
  }

  .error-text {
    margin-top: 1px;
  }

  .icon-container {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--rekki-light);
    margin-right: 8px;
  }
</style>
